// @flow
import styled from 'styled-components'
import { Row, Layout } from 'antd'

const { Content } = Layout

export const StyledRow = styled(Row) `
  padding-top: 20px;
  text-align: right;
  & button {
    width: 100%;
    max-width: 100px;
    margin-left: 10px;
  }
`
export const StyledContent = styled(Content) `
  margin: 24px 16px;
`




// WEBPACK FOOTER //
// ./src/components/customer-support/style.js